/* eslint-disable react/no-array-index-key */
import React from 'react';
import get from 'lodash/get';

import { SEASON } from '../../../../constants';
import Product from '../../Product';
import fffBox from './fff-box.png';
import styles from './styles.module.scss';

const getBoxName = (seasonCode) => {
  const year = seasonCode.substr(0, 2);
  const seasonNum = seasonCode.substr(2, 2);
  const season = get(SEASON, seasonNum, '');
  return `${season} 20${year} Box`;
};

const Box = ({ box }) => (
  <div className={styles.box} data-testid="box-container">
    <div className={styles['box-header']} data-testid="box-header">
      <img src={fffBox} alt="FFF Box" data-testid="box-image"/>
      <div className={styles['box-info']}>
        <h1>{getBoxName(box.seasonCode)}</h1>
        <p className={styles.description}>Up to $300 value (depending on choices)</p>
        <p className={styles.note}>
          Subscription charge is included in your order total where applicable.
        </p>
      </div>
    </div>
    <ul>
      {box.items.map(({ name, brandName, title, imageUrl, autoAssigned, slug }, index) => (
        <Product
          key={index}
          name={name}
          brandName={brandName}
          title={title}
          imageUrl={imageUrl}
          autoAssigned={autoAssigned}
          slug={slug}
        />
      ))}
    </ul>
  </div>
);

export default Box;
